import { Link } from "react-router-dom";
import freshLogo from "assets/images/Fresh.png";
import esportsLogo from "assets/images/Logo.png";

function SideBar({
  isLoggedIn,
  nickname,
}: {
  isLoggedIn?: boolean;
  nickname?: string | null;
}) {
  return (
    <div className="sidebar">
      <h2>
        <img src={esportsLogo} className="side-logo" alt="Jiwe eSports logo" />
      </h2>
      {/* <input className="search" type="search" name="" placeholder="Search" /> */}
      <ul>
        <li>
          <Link to="/dashboard">Dashboard</Link>
        </li>
        <li>
          <Link to="/hub-registration">
            <span style={{ color: "yellow" }}>Hub Registration</span>
          </Link>
        </li>
        {isLoggedIn && (
          <>
            <li>
              <Link to={`/profile/${nickname}`}>Profile</Link>
            </li>
            <li>
              <Link to={`/profile/${nickname}/stats`}>Stats</Link>
            </li>
            {/* <li>
              <Link to="/sponsor-page">Sponsor Page</Link>
            </li>
            <li>
              <Link to="/live-page">Live Page</Link>
            </li> */}
            <li>
              <Link to="/leaderboard">Leaderboard</Link>
            </li>
          </>
        )}
        <li>
          <Link to="/tournaments">Tournaments</Link>
        </li>
        <li>
          <Link to="/games">Games</Link>
        </li>
        {/* <li>
          <Link to="/news">News</Link>
        </li> */}
        <li>
          <a href="#">
            <img src={freshLogo} className="sponsor" alt="Sponsor Logo" />
          </a>
        </li>
      </ul>
    </div>
  );
}

export default SideBar;
